import { TemplatesFlowcodeBtnProps } from './TemplatesFlowcodeBtn.types'
import { parseMyFlowcodesResponse, parseMyFoldersResponse } from '../../../utils/my-flowcodes'
import { useAuthState } from '@dtx-company/inter-app/src/hooks/useAuthState'
import { useFetchFlowcodes, useFetchFolders } from '../../../hooks/swr/codes'
import { useMemo } from 'react'

export const useTemplatesFlowcodeBtn = ({
  onClickCreateFlowcode,
  onClickSelectFlowcode
}: Pick<TemplatesFlowcodeBtnProps, 'onClickCreateFlowcode' | 'onClickSelectFlowcode'>): {
  label: string
  userHasFlowcodes: boolean
  isLoading: boolean
  showAsLink: boolean
  handleClick: () => void
} => {
  const { isAuthenticated, token } = useAuthState()

  const { data: foldersResponse, isLoading: isLoadingFoldersResponse } = useFetchFolders({
    parentDirectoryId: ''
  })

  const { data: flowcodesResponse, error: flowcodesResponseError } = useFetchFlowcodes(
    false,
    {
      withStudioConfig: true
    },
    token
  )

  const isLoadingFlowcodesResponse = !flowcodesResponse && !flowcodesResponseError

  const parsedFoldersResponse = useMemo(
    () => parseMyFoldersResponse(foldersResponse),
    [foldersResponse]
  )
  const foldersContainsCode = useMemo(() => {
    return parsedFoldersResponse?.folders?.some(folder => Boolean(folder.batchCount))
  }, [parsedFoldersResponse?.folders])

  const parsedFlowcodesResponse = useMemo(
    () => parseMyFlowcodesResponse(flowcodesResponse),
    [flowcodesResponse]
  )

  const userHasFlowcodes =
    (Boolean(parsedFoldersResponse?.folders?.length) && Boolean(foldersContainsCode)) ||
    Boolean(parsedFlowcodesResponse?.flowcodes?.length)

  const label = isAuthenticated && userHasFlowcodes ? 'Select your Flowcode' : 'Create a Flowcode'
  const showAsLink = label === 'Create a Flowcode'
  const isLoading = isAuthenticated ? isLoadingFlowcodesResponse || isLoadingFoldersResponse : false

  const handleClick = (): void => {
    if (showAsLink) {
      onClickCreateFlowcode()
    } else {
      onClickSelectFlowcode()
    }
  }

  return {
    label,
    userHasFlowcodes,
    isLoading,
    handleClick,
    showAsLink: label === 'Create a Flowcode'
  }
}
